/**
 * Adressen til Control Room › Artistskanning (QA13 #3, før Offisiell liste og Byråskanning): fanen, søket, byråfilteret og artisten som er åpen.
 * «Må sjekkes» lenker hit med `artist` og `q`, så panelet åpner seg på artisten som skal rettes.
 */
/* «Kjøringer» (QA13 #3): tidsplanen, «Kjør nå» og loggen, fra den gamle siden Byråskanning. */
export const OFFICIAL_TABS = ['artists', 'agencies', 'review', 'runs'] as const;
export type OfficialTab = (typeof OFFICIAL_TABS)[number];

export interface OfficialSearch {
  tab?: OfficialTab;
  q?: string;
  agency?: string;
  artist?: string;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined;

export function validateOfficialSearch(search: Record<string, unknown>): OfficialSearch {
  const out: OfficialSearch = {};
  const tab = search['tab'];
  if (typeof tab === 'string' && (OFFICIAL_TABS as readonly string[]).includes(tab)) {
    out.tab = tab as OfficialTab;
  }
  const q = text(search['q']);
  if (q !== undefined) out.q = q;
  const agency = text(search['agency']);
  if (agency !== undefined) out.agency = agency;
  const artist = text(search['artist']);
  if (artist !== undefined) out.artist = artist;
  return out;
}
